// extracted by mini-css-extract-plugin
module.exports = {"link":"viewlink-module--link--2SUf0"};